module.exports = __webpack_public_path__ + "img/user-slash.e5524bb6.svg";